import { SalutationType } from "../../../models/enums/salutationType.enum";

/**
 * initialData: object - The initial data for the registration form.
 */
export const initialData = {
  first_name: "",
  last_name: "",
  guardian_email: "",
  email: "",
  birthday: "",
  group_keys: "",
  street: "",
  street_number: "",
  zip_code: "",
  city: "",
  password: "",
  salutation: "",
  confirmPassword: "",
  terms_agreed_at: "",
};

export const NewEventParticipantinitialData = {
  first_name: "",
  last_name: "",
  guardian_email: "",
  email: "",
  birthday: "",
  street: "",
  street_number: "",
  zip_code: "",
  city: "",
  password: "",
  salutation: SalutationType.Neutral,
  confirmPassword: "",
  email_or_username: "",
  terms_agreed_at: "",
};
